module.exports = __webpack_public_path__ + "static/img/bg-sai-file.5663bf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-sai-file.png
// module id = 815
// module chunks = 0